import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ControlLabel } from '../ControlLabel';
import { VisuallyHidden } from '../VisuallyHidden';

function FormGroupLabel(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$labelHidden = _ref.labelHidden,
      labelHidden = _ref$labelHidden === void 0 ? false : _ref$labelHidden,
      props = _objectWithoutProperties(_ref, ["children", "id", "labelHidden"]);

  if (!children) return null;

  if (labelHidden) {
    return /*#__PURE__*/React.createElement(VisuallyHidden, {
      as: "label",
      htmlFor: id
    }, children);
  }

  return /*#__PURE__*/React.createElement(ControlLabel, props, children);
}

export default /*#__PURE__*/React.memo(FormGroupLabel);